/**
 * @author: lv.chen
 * @date: 2025/4/27
 * @desc: 简单版标签组件，用于纯展示
 */
import React from 'react';
import classnames from 'classnames';

import './index.scss';

import type { IBaseProps } from '@home/types/common';

export type IGeneralTagFormatter = (text?: string) => React.ReactNode;

interface IGeneralTagProps extends IBaseProps {
  text?: string;
  formatter?: IGeneralTagFormatter;
}

const GeneralTag: React.FC<IGeneralTagProps> = (props) => {
  const { style, className, text, formatter } = props;

  const formattedText = formatter?.(text) ?? text;

  if (!formattedText) return null;
  return (
    <div style={style} className={classnames('dbg-general-tag', className)}>
      {formattedText}
    </div>
  );
};

export default GeneralTag;
